var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.24 5.56483C26.24 2.49146 23.7485 0 20.6752 0H6.39784C3.32447 0 0.833008 2.49146 0.833008 5.56483V19.4352C0.833008 22.5085 3.32447 25 6.39784 25H20.6752C23.7485 25 26.24 22.5085 26.24 19.4352V5.56483ZM39.1664 5.69801C39.1664 5.31646 39.0683 4.94132 38.8815 4.60859C38.4679 3.87155 37.6973 3.461 36.9077 3.47189L36.6922 3.48538C36.4048 3.51749 36.119 3.60647 35.851 3.75689L29.1595 7.51241C28.4575 7.90637 28.0229 8.6486 28.0229 9.45353V14.628C28.0229 15.433 28.4575 16.1752 29.1595 16.5691L35.851 20.3247C36.1837 20.5114 36.5589 20.6095 36.9404 20.6095L37.1548 20.5993C38.2836 20.4914 39.1664 19.5406 39.1664 18.3835V5.69801Z",
    fill: "#007E73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCameraIcon);
export default __webpack_public_path__ + "static/media/video-camera-icon.98d68c606738368453fab9f444f90ec2.svg";
export { ForwardRef as ReactComponent };